import React, { useEffect } from 'react';
import { create } from 'zustand';
import { HashRouter } from 'react-router';
import { ApptekstProvider } from './contexts/ApptekstContext';
import * as api from './utils/api';
import { SVVSpinner } from '@komponentkassen/svv-spinner';
import { TekniskFeil } from './components/TekniskFeil';

import './App.scss';

import InnloggedeSider from './page/InnloggedeSider';

type AppState = {
    tekniskFeil?: string;
    setTekniskFeil: (tekniskFeil?: string) => void;
};

export const useAppState = create<AppState>((set) => ({
    tekniskFeil: undefined,
    setTekniskFeil: (tekniskFeil) => set(() => ({ tekniskFeil })),
}));

const App = () => {
    const tekniskFeil = useAppState((state) => state.tekniskFeil);

    useEffect(() => {
        if (tekniskFeil) {
            api.loggFeil(tekniskFeil);
        }
    }, [tekniskFeil]);

    return (
        <div className="nytt-design">
            <ApptekstProvider
                appnavn={['personlig-kjennemerke']}
                loadingComponent={<SVVSpinner size="large" />}
            >
                <HashRouter>
                    <div className="svv-side">
                        <div
                            className="svv-container--secondary"
                            aria-live="assertive"
                        >
                            {tekniskFeil && <TekniskFeil />}
                        </div>
                        <InnloggedeSider />
                    </div>
                </HashRouter>
            </ApptekstProvider>
        </div>
    );
};

export default App;
